import { AccountingState } from '@mews-commander/data-access';
import { Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface OrderItemStateTagProps {
    orderItemState: AccountingState;
}

const OrderItemStateTag = ({ orderItemState }: OrderItemStateTagProps) => {
    const getLocalizedTextKey = () => {
        switch (orderItemState) {
            case AccountingState.Open:
                return TextKey.Open;
            case AccountingState.Closed:
                return TextKey.Closed;
            case AccountingState.Canceled:
                return TextKey.Canceled;
            case AccountingState.Inactive:
                return TextKey.Inactive;
            default:
                return TextKey.Open;
        }
    };

    return (
        <Tag variant="basicSubtle">
            <LocalizedText textKey={getLocalizedTextKey()} />
        </Tag>
    );
};

export default OrderItemStateTag;
